/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import OutlineButton from '../../MUICustomButton/OutlineButton';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_EMAIL, ERR_EMAIL_INVALID, UNKNOWN_ERR, ERR_CONNECTION_NAME_REQUIRED } from 'src/constants/constant';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled, TextField } from '@mui/material';
import type { EditESPFormInputs, RootState } from '../../types/types';
import GradientButton from '../../MUICustomButton/GradientButton';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';
import Button from '../../CustomButton/Button';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import { getESPConnectionData, getESPConnectionDataById, updateESPData } from 'src/services/emailAPIESPServices';

//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
export interface PropsType {
    espId?: string;
    espData?: any;
    step?: string;
    onCancel: () => void;
}

const urlRegx = /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\?.*)?$/gm;

const validationSchema = Yup.object().shape({
    connectionName: Yup.string().required(ERR_CONNECTION_NAME_REQUIRED).matches(/^\S.*\S$|^\S$/, "Please enter a valid connection name"),
    connectionTypeId: Yup.number().required("Please select email service provider"),
    domain: Yup.string().required("Please enter the domain name")
        .matches(
            /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/,
            "Enter a valid domain name"
        ),
    viewEmailDomainURL: Yup.string().required("Please enter view in browser URL")
        .matches(
            urlRegx,
            "Enter a valid URL"
        ),
    fromName: Yup.string().required("Please enter the from name").matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, "Please enter a valid from name"),
    fromEmail: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        )
        .test(
            'matches-domain',
            "Email domain must match the provided domain",
            function (value) {
                if (!value) return true; // Skip validation if empty (already handled by required)
                const emailDomain = value.split('@')[1];
                return emailDomain === this.parent.domain; // Compare with domain field
            }
        ),
    replyToEmail: Yup.string()
            .required(ERR_EMAIL)
            .email(ERR_EMAIL_INVALID)
            .test(
                'is-valid-email',
                ERR_EMAIL_INVALID,
                (value) => value === '' || EmailValidator.validate(value),
            ),

    dailyCount: Yup.number().typeError("Only numbers are allowed")
        .integer("Only whole numbers are allowed")
        .test(
            "is-strict-integer",
            "Only whole numbers are allowed",
            (value, context) => {
              return /^\d+$/.test(context.originalValue); // Ensures no decimals or just "."
            }
        )
        .min(1, "Value must be greater than 0")
        .max(1000000, "Value cannot exceed 10 lakh")
        .required("Daily count is required"),
    
    hourlyCount: Yup.number().typeError("Only numbers are allowed")
        .integer("Only whole numbers are allowed")
        .test(
            "is-strict-integer",
            "Only whole numbers are allowed",
            (value, context) => {
              return /^\d+$/.test(context.originalValue); // Ensures no decimals or just "."
            }
        )
        .min(1, "Value must be greater than 0")
        .max(1000000, "Value cannot exceed 10 lakh")
        .required("Hourly count is required"),
    
    hasWarmup: Yup.boolean().required("Please select warmup"),
    
    warmupStartCount: Yup.number()
        .transform((value, originalValue) => originalValue === "" ? undefined : value) // Prevent NaN errors
        .when("hasWarmup", {
            is: true,
            then: (schema) => schema
                .typeError("Only whole numbers are allowed")
                .integer("Only whole numbers are allowed")
                .test(
                    "is-strict-integer",
                    "Only whole numbers are allowed",
                    (value, context) => value !== undefined && /^\d+$/.test(context.originalValue)
                )
                .min(1, "Must be at least 1")
                .max(1000000, "Value cannot exceed 10 lakh")
                .required("Warmup start count is required"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    warmupTrackingDays: Yup.number()
        .transform((value, originalValue) => originalValue === "" ? undefined : value) // Prevent NaN errors
        .when("hasWarmup", {
            is: true,
            then: (schema) => schema
                .typeError("Only whole numbers are allowed")
                .integer("Only whole numbers are allowed")
                .test(
                    "is-strict-integer",
                    "Only whole numbers are allowed",
                    (value, context) => value !== undefined && /^\d+$/.test(context.originalValue)
                )
                .min(1, "Must be at least 1")
                .max(365, "Must not exceed 365")
                .required("Warmup Tracking Days is required"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    warmupMultiplier: Yup.number()
        .transform((value, originalValue) => originalValue === "" ? undefined : value) // Prevent NaN errors
        .when("hasWarmup", {
            is: true,
            then: (schema) => schema
                .typeError("Only decimal values are allowed")
                .moreThan(0, "Must be greater than 0")
                .max(9999999.9999999, "Value cannot exceed 9,999,999.9999999")
                .test("is-decimal", "Only decimal values are allowed", (value) => value !== undefined && !Number.isInteger(value))
                .required("Warmup multiplier is required"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    asmGroupId: Yup.number()
        .transform((value, originalValue) => {
            // Handle empty strings cleanly (treat as undefined)
            if (typeof originalValue === 'string') {
            const trimmed = originalValue.trim();
            if (trimmed === '') return undefined;
            if (/^\d+$/.test(trimmed)) return Number(trimmed);
            }
            return originalValue;
        })
        .typeError("Only whole numbers are allowed")
        .integer("Only whole numbers are allowed")
        .min(1, "Value must be greater than 0")
        .max(1000000, "Value cannot exceed 10 lakh")
        .when('connectionTypeId', {
            is: (val: number) => val !== 1,
            then: (schema) => schema.required("ASM Group ID is required"),
            otherwise: (schema) => schema.notRequired().nullable()
        }),
    espAccountKey: Yup.string().required("ESP Account Key is required").matches(/^\S.*\S$|^\S$/, "Please enter a valid ESP account key"),    
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


function EditESPForm({ espId, espData, step, onCancel }: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [selectedClientData, setSelectedESPData] = useState<any>()
    const [showClientConfigurationModal, setShowClientConfigurationModal] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const [formValueUpdated, setFormValueUpdated] = useState<boolean>(false)
    const [openConfirmPopup, setOpenConfirmPopup] = useState<boolean>(false);
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);
    const [showImportMappingModal, setShowImportMappingModal] = useState<boolean>(false);
    const [showExportMappingModal, setShowExportMappingModal] = useState<boolean>(false);

    const [espConnectionData, setESPConnectionData] = useState<any>([])

    const {
        control,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm<EditESPFormInputs>({
        resolver: yupResolver(validationSchema),
    });

    const hasWarmup = watch("hasWarmup");
    useEffect(() => {
        console.log("hasWarmup changed:", hasWarmup);
    }, [hasWarmup]);

    const getClientDetails = (): void => {
        setIsDataLoading(true)
        if (espId) {
            getESPConnectionDataById(espId).then(
                (res: any) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            setSelectedESPData(res.data.data[0])
                            const espDataArr: any = res.data.data[0]
                            setValue("domain", espDataArr.domain)
                            setValue("fromName", espDataArr.fromName)
                            setValue("fromEmail", espDataArr.fromEmail)
                            
                            setValue("connectionTypeId", espDataArr.connectionTypeId ? espDataArr.connectionTypeId.toString() : "0")
                            setValue("dailyCount", espDataArr.dailyCount)
                            setValue("hourlyCount", espDataArr.hourlyCount)
                            setValue("warmupStartCount", espDataArr.warmupStartCount)
                            setValue("warmupMultiplier", espDataArr.warmupMultiplier)
                            setValue("warmupTrackingDays", espDataArr.warmupTrackingDays)
                            setValue("hasWarmup", espDataArr.hasWarmup)
                            setValue("espAccountKey", espDataArr.espAccountKey)
                            setValue("asmGroupId", espDataArr.asmGroupId)
                            setValue("connectionName", espDataArr.connectionName)
                            setValue("viewEmailDomainURL", espDataArr.viewEmailDomainURL)
                            setValue("replyToEmail", espDataArr.replyToEmail);
                        }

                    }
                }
            )
                .catch(
                    error => console.log("Error: ", error)
                )
                .finally(() => {
                    setIsDataLoading(false)
                })
        }

    }

    useEffect(() => {
        getClientDetails()
    }, [espId, espData])

    useEffect(() => {
        getESPConnectionData().then(
            (res: any) => {
                if(res.status === 200) {
                    if(res.data.result === 1) {
                        setESPConnectionData(res.data.data)
                    }
                }
            }
        )
        .catch(
            (error) => console.log(error)
        )
    }, [])

    const onSubmit = async (data: EditESPFormInputs): Promise<void> => {
        setIsLoading(true)


        const requestParams = {
            "id": espData.id,
            "connectionTypeId": data.connectionTypeId,
            "domain": data.domain,
            "fromEmail": data.fromEmail,
            "fromName": data.fromName,
            "dailyCount": data.dailyCount,
            "hourlyCount": data.hourlyCount,
            "modifiedBy": user?.id,
            "nextDeliveryTime": new Date().toISOString(),
            "warmupStartCount": data.warmupStartCount,
            "warmupMultiplier": data.warmupMultiplier,
            "warmupTrackingDays": data.warmupTrackingDays,
            "hasWarmup": data.hasWarmup,
            "connectionName": data.connectionName,
            "espAccountKey": data.espAccountKey,
            "asmGroupId": data.asmGroupId,
            "viewEmailDomainURL": data.viewEmailDomainURL,
            "replyToEmail": data.replyToEmail,
        }

        try {
            //@ts-ignore
            const res = await updateESPData(requestParams);
            
            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success("ESP updated successfully");

                    setTimeout(() => {
                        onCancel()
                    }, 1000)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                    NotificationManager.error(errorMsg.includes('ESP name already exists') ? 'ESP name already exists' : UNKNOWN_ERR, '', 5000);
                }
            }
        } catch (error) {
            console.error("Error occurred:", error);
            NotificationManager.error("Unknown error has occurred");
        } finally {
            setIsLoading(false);
        }
    }

    const handleFormReset = (): void => {
        onCancel()
    }

    const handleClientConfiguration = (): void => {
        setShowClientConfigurationModal(true)
    }

    const handleConfirmClose = (): void => {
        setOpenConfirmPopup(false)
    }
    const handleCloseClientConfiguration = (status: string | null = null): void => {
        if (status === null && formValueUpdated === true) {
            setOpenConfirmPopup(true)
        } else {
            setShowClientConfigurationModal(false)
        }
    }
    const handleFormValueUpdated = (value: boolean): void => {
        setFormValueUpdated(value)
    }
    const handleConfirmOpen = (): void => {
        setShowImportMappingModal(false)
        setShowExportMappingModal(false)
        setShowClientConfigurationModal(false)
        setFormValueUpdated(false)
        setOpenConfirmPopup(false)
    }

    return (
        <>
            <div >
                {
                    isDataLoading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                console.log('Form data:', errors);
                                void handleSubmit(onSubmit)(e);
                            }}
                        >
                            {
                                step === "1" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="connectionName"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="Connection Name*"
                                                                autoComplete="off"
                                                                placeholder="Connection Name*"
                                                                error={Boolean(errors.connectionName)}
                                                            />
                                                            {errors.connectionName && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.connectionName.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="domain"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"Domain Name*"}
                                                                autoComplete="off"
                                                                placeholder={"Domain Name*"}

                                                                error={Boolean(errors.domain)}
                                                            />
                                                            {errors.domain && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.domain.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className="mb-[30px]">
                                            <Controller
                                                name="connectionTypeId"
                                                control={control}
                                                rules={{ required: "Please select an email service provider" }}
                                                render={({ field }) => {
                                                    const options = [
                                                        { label: "Mailgun", value: 1 },
                                                        { label: "Sendgrid", value: 2 },
                                                    ];

                                                    // Find the selected option based on field.value (return undefined if not found)
                                                    const selectedOption = options.find(option => option.value === Number(field.value)) ?? undefined;
                                                    return (
                                                        <Autocomplete
                                                            options={options}
                                                            getOptionLabel={(option) => option.label}
                                                            isOptionEqualToValue={(option, value) => option.value === value?.value} // Ensures correct selection
                                                            popupIcon={
                                                              <HugeiconsIcon
                                                                icon={ArrowDown01Icon}
                                                                size={18}
                                                                color="#3A3A3A"
                                                                strokeWidth={0.2}
                                                            
                                                              />
                                                            }
                                                            value={selectedOption} // Ensure correct default selection (undefined when empty)
                                                            onChange={(_, selectedOption) => {
                                                                field.onChange(selectedOption?.value ?? undefined); // Update only the value
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Email Service Provider*"
                                                                    placeholder="Select Email Service Provider"
                                                                    error={Boolean(errors.connectionTypeId)}
                                                                    helperText={errors.connectionTypeId?.message}
                                                                />
                                                            )}
                                                            disableClearable
                                                        />
                                                    );
                                                }}
                                            />
                                        </div>

                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="viewEmailDomainURL"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"View in Browser URL*"}
                                                                autoComplete="off"
                                                                placeholder={"View in Browser URL*"}

                                                                error={Boolean(errors.viewEmailDomainURL)}
                                                            />
                                                            {errors.viewEmailDomainURL && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.viewEmailDomainURL.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="fromName"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="From Name*"
                                                                autoComplete="off"
                                                                placeholder="From Name*"
                                                                error={Boolean(errors.fromName)}
                                                            />
                                                            {errors.fromName && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.fromName.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="fromEmail"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="From Email*"
                                                                autoComplete="off"
                                                                placeholder="From Email*"
                                                                error={Boolean(errors.fromEmail)}
                                                            />
                                                            {errors.fromEmail && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.fromEmail.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="replyToEmail"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="Reply to Email Address*"
                                                                autoComplete="off"
                                                                placeholder="Reply to Email Address*"
                                                                error={Boolean(errors.replyToEmail)}
                                                            />
                                                            {errors.replyToEmail && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.replyToEmail.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            {
                                step === "4" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="espAccountKey"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"ESP Account Key*"}
                                                                autoComplete="off"
                                                                placeholder={"ESP Account Key"}
                                                                error={Boolean(errors.espAccountKey)}
                                                            />
                                                            {errors.espAccountKey && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.espAccountKey.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="asmGroupId"
                                                    control={control}
                                                    defaultValue={0}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"ASM GroupId*"}
                                                                autoComplete="off"
                                                                placeholder={"ASM GroupId"}
                                                                error={Boolean(errors.asmGroupId)}
                                                            />
                                                            {errors.asmGroupId && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.asmGroupId.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            {
                                step === "2" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="dailyCount"
                                                    control={control}
                                                    defaultValue={0}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"Daily Limit*"}
                                                                autoComplete="off"
                                                                placeholder={"Daily Limit"}
                                                                error={Boolean(errors.dailyCount)}
                                                            />
                                                            {errors.dailyCount && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.dailyCount.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="hourlyCount"
                                                    control={control}
                                                    defaultValue={0}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"Hourly Limit*"}
                                                                autoComplete="off"
                                                                placeholder={"Hourly Limit"}
                                                                error={Boolean(errors.hourlyCount)}
                                                            />
                                                            {errors.hourlyCount && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.hourlyCount.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                            {
                                step === "3" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className="w-full relative">
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="hasWarmup"
                                                    control={control}
                                                    render={({ field }) => {
                                                        const options = [
                                                            { label: "Yes", value: true },
                                                            { label: "No", value: false },
                                                        ];

                                                        // Find the selected option based on field.value
                                                        const selectedOption = options.find(option => option.value === field.value) ?? undefined;

                                                        return (
                                                            <Autocomplete
                                                                options={options}
                                                                getOptionLabel={(option) => option.label} // Display Yes/No
                                                                isOptionEqualToValue={(option, value) => option.value === value?.value} // Correct value comparison
                                                                popupIcon={
                                                                  <HugeiconsIcon
                                                                    icon={ArrowDown01Icon}
                                                                    size={18}
                                                                    color="#3A3A3A"
                                                                    strokeWidth={0.2}
                                                                
                                                                  />
                                                                }
                                                                value={selectedOption} // Ensure correct value selection
                                                                onChange={(_, selectedOption) => {
                                                                    field.onChange(selectedOption?.value ?? false); // Ensure boolean value is stored
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Warmup*"
                                                                        placeholder="Select Warmup"
                                                                        error={Boolean(errors.hasWarmup)}
                                                                        helperText={errors.hasWarmup?.message}
                                                                    />
                                                                )}
                                                                disableClearable
                                                            />
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="warmupMultiplier"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="Multiplier"
                                                                autoComplete="off"
                                                                placeholder="Multiplier"
                                                                error={Boolean(errors.warmupMultiplier)}
                                                                disabled={!hasWarmup}
                                                            />
                                                            {errors.warmupMultiplier && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.warmupMultiplier.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="warmupTrackingDays"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"Warmup Tracking Days"}
                                                                autoComplete="off"
                                                                placeholder={"Warmup Tracking Days"}
                                                                error={Boolean(errors.warmupTrackingDays)}
                                                                disabled={!hasWarmup}
                                                            />
                                                            {errors.warmupTrackingDays && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.warmupTrackingDays.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="warmupStartCount"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="Warmup Start Count"
                                                                autoComplete="off"
                                                                placeholder="Warmup Start Count"
                                                                error={Boolean(errors.warmupStartCount)}
                                                                disabled={!hasWarmup}
                                                            />
                                                            {errors.warmupStartCount && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.warmupStartCount.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            <div className='flex gap-2 justify-end'>
                                <OutlineButton color='gray' onClick={() => handleFormReset()} width='130px'>Cancel</OutlineButton>
                                <GradientButton type='submit' color='red' onClick={handleFormReset} width='130px'>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                            </div>

                        </form>
                }
            </div>
            <BootstrapDialog
                onClose={handleConfirmClose}
                aria-labelledby="customized-dialog-title"
                open={openConfirmPopup}
                PaperProps={{
                    sx: {
                        width: '550px',
                        height: '200px'
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    Review changes
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleConfirmClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                   <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
                </IconButton>
                <DialogContent>
                    <p className='text-14 text-muted'>{`You haven't saved your changes. Are you sure you want to leave the page?`}</p>
                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <Button btntype={"button"} onClick={handleConfirmClose} label={"Cancel"} type={'default'} size={'small'} disabled={isModalSaveLoading}></Button>
                    <Button btntype="submit" label={!isModalSaveLoading ? "Discard" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleConfirmOpen} disabled={isModalSaveLoading}></Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    )
}

export default EditESPForm